<div>
  <div class="pcl-control-label mat-dialog-title">
    <span>Share Job Posting</span>
  </div>
  <div
    class="mat-dialog-content"
    [class.dialog-width-auto]="breakpointService.isMobile"
    [class.dialog-width-400]="!breakpointService.isMobile">
    <div>
      <div>
        <span class="pcl-body bold">{{ posting.jobTitle }}</span>
      </div>
      <div>
        <span class="pcl-body">
          <span class="pcl-body">{{ getPostingLocationDisplayString(posting) }}</span>
        </span>
      </div>
    </div>
    <div class="flex-container margin-vertical-16">
      <input type="url" mat-input readonly class="posting-url" [value]="postingUrlDisplay" />
      <button
        mat-flat-button
        color="primary"
        class="pcl-control-label"
        [cdkCopyToClipboard]="postingUrl.href"
        (click)="copyToClipboard()">
        Copy
      </button>
    </div>
    <mat-divider class="margin-vertical-16"></mat-divider>
    <p class="pcl-control-label bold">Share Link To:</p>
    <div class="flex-container column">
      <a target="_blank" rel="noopener noreferrer" [href]="getFacebookShareUrl()">
        <div class="container">
          <span class="share-icon">
            <fa-icon [icon]="faFacebook" size="lg"></fa-icon>
          </span>
          <span class="pcl-control-label pcl-green">Facebook</span>
        </div>
      </a>
      <a target="_blank" rel="noopener noreferrer" [href]="getTwitterShareUrl()">
        <div class="container">
          <span class="share-icon">
            <fa-icon [icon]="faXTwitter" size="lg"></fa-icon>
          </span>
          <span class="pcl-control-label pcl-green">X, formerly known as Twitter</span>
        </div>
      </a>
      <a target="_blank" rel="noopener noreferrer" [href]="getLinkedInShareUrl()">
        <div class="container">
          <span class="share-icon">
            <fa-icon [icon]="faLinkedin" size="lg"></fa-icon>
          </span>
          <span class="pcl-control-label pcl-green">LinkedIn</span>
        </div>
      </a>
    </div>
  </div>
</div>
